var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelatoriopendencia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 14.375C9.375 15.7011 9.90178 16.9729 10.8395 17.9105C11.7771 18.8482 13.0489 19.375 14.375 19.375C15.7011 19.375 16.9729 18.8482 17.9105 17.9105C18.8482 16.9729 19.375 15.7011 19.375 14.375C19.375 13.0489 18.8482 11.7771 17.9105 10.8395C16.9729 9.90178 15.7011 9.375 14.375 9.375C13.0489 9.375 11.7771 9.90178 10.8395 10.8395C9.90178 11.7771 9.375 13.0489 9.375 14.375Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.585 14.375H14.375V12.165M3.125 5.625H11.875M3.125 9.375H8.125M3.125 13.125H6.25M6.25 16.875H1.875C1.54348 16.875 1.22554 16.7433 0.991117 16.5089C0.756696 16.2745 0.625 15.9565 0.625 15.625V1.875C0.625 1.54348 0.756696 1.22554 0.991117 0.991117C1.22554 0.756696 1.54348 0.625 1.875 0.625H10.7325C11.0638 0.625071 11.3815 0.756651 11.6158 0.990833L14.0092 3.38417C14.2433 3.6185 14.3749 3.93621 14.375 4.2675V6.25",
    stroke: "#F8F8F8",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatoriopendencia);
export default __webpack_public_path__ + "static/media/relatoriopendencia.094a4892.svg";
export { ForwardRef as ReactComponent };